<template>
    <div class="drag_content">
        <draggable v-model="list" @start="drag = true" @end="drag = false" @change="list_change" item-key="id"
                   style="width: 100%;">
            <template #item="{ element, index }">
                <div>
                    
                    
                    <div class="drag_content_info">
                        <div class="gailv_chongwenbao" :style="'background: url(' + element.chongwenbao_url + ') no-repeat;background-size: 100% 100%;'">
                            <span style="font-size: 6px;">{{ element.toudang_gailv }}</span>
                            <span style="font-size: 8px;">{{ element.chongwenbao }}</span>
                        </div>
                        <div style="height:30px;position:absolute;top: 0;left: 30px;"
                             v-if="(batch_model === 'major_group' && element.group_new_major === 1) || batch_model === 'school_strategy' && element.school_new_major === 1">
                            <img style="height:30px;" src="https://oss.shudaozaixian.com/wechat/new_major.png">
                        </div>
                        <div
                            style="position: absolute;top:0;left: 0;width:60px;height:110px;display: flex;justify-content: center;align-items: center;z-index: 99999999;">
                            <el-popover :ref="`el_popover_${index}`" placement="bottom" :width="260" trigger="click">
                                <template #reference>
                                    <div
                                        style="height:30px;width: 50px;cursor: pointer;color: #333333;font-size: 16px;display: flex;justify-content: center;align-items: center;">
                                        <div>{{ element.user_score_rank }}</div>
                                        <el-icon>
                                            <ArrowDown/>
                                        </el-icon>
                                    </div>
                                </template>
                                <div style="display:flex;justify-content: center;align-items: center;">
                                    <div>第</div>&nbsp;&nbsp;
                                    <el-input v-model="index_rank" @input="input" style="width: 100px;"
                                              placeholder="N"></el-input>&nbsp;&nbsp;
                                    <div>志愿</div>&nbsp;&nbsp;
                                    <el-button style="background-color: #e93a29;color: white;"
                                               @click="change_rank(element, index)">
                                        确定
                                    </el-button>
                                </div>
                            </el-popover>
                        </div>
                        <div class="drag_content_list">
                            <div class="drag_content_list_item">
                                <div style="width: 60px;height:30px;"></div>
                                <div style="width: 300px;white-space: nowrap;overflow: hidden;">
                                    {{ element.school_name }}
                                </div>
                                <div style="white-space: nowrap;overflow: hidden;font-size:12px;color: #999999">
                                    <div v-for="(label, index) in element.label_list"
                                         style="margin-right: 3px;font-size:12px;display: inline-block;" :key="index">
                                        {{ label }} /
                                    </div>
                                </div>
                            </div>
                            <div class="drag_content_list_item">
                                <div style="width: 60px;height:30px;"></div>
                                <div style="width: 300px;white-space: nowrap;overflow: hidden;">
                                <span v-if="batch_model === 'major_group'">
                                    {{ element.major_group_code }}<span
                                    v-if="element.major_group_code.length > 0">组</span>
                                </span>
                                    <span v-else>{{ element.danlie_biaoshi }}</span>
                                </div>
                                <div style="white-space: nowrap;overflow: hidden;font-size:12px;color: #999999">
                                    <div>
                                        校友会:{{ element.xyh_sort < 10000 ? element.xyh_sort : '无' }} /
                                        软科:{{ element.ruanke_sort < 10000 ? element.ruanke_sort : '无' }} /
                                        QS:{{ element.qs_sort < 10000 ? element.qs_sort : '无' }}
                                    </div>
                                </div>
                            </div>
                            <div class="drag_content_list_item">
                                <div style="width: 60px;height:30px;"></div>
                                <div style="width: 300px;white-space: nowrap;overflow: hidden;">
                                
                                </div>
                                <div v-if="batch_model === 'major_group'" style="font-size:12px;color: #999999;">
                                    人数:{{ element.group_num }}
                                    选科:{{ element.major_group_rule }}
                                </div>
                                <div v-else style="font-size:12px;color: #999999;">
                                    人数:{{ element.school_num }}
                                </div>
                            </div>
                        </div>
                        <div style="width: 250px;font-size:12px;color:#999999;">
                            <div style="height:20px;line-height:20px;display: flex;justify-content: right;align-items: center;">
                                <div style="width: 50px;text-align: center"></div>
                                <div style="width: 50px;text-align: center">人数</div>
                                <div style="width: 50px;text-align: center">分数</div>
                                <div style="width: 50px;text-align: center">线差</div>
                                <div style="width: 50px;text-align: center">位次</div>
                            </div>
                            <div
                                style="height:20px;line-height:20px;display: flex;justify-content: right;align-items: center;"
                                v-for="(info, year) in element.historical_data">
                                <div style="width: 50px;text-align: center">{{ year }}</div>
                                <div style="width: 50px;text-align: center">{{ info.number_basics }}</div>
                                <div style="width: 50px;text-align: center">{{ info.low_score_basics }}</div>
                                <div style="width: 50px;text-align: center">{{ info.line_diff_basics }}</div>
                                <div style="width: 50px;text-align: center">{{ info.precedence_basics }}</div>
                            </div>
                        </div>
                        <div
                            style="width: 80px;display: flex;flex-direction: column;align-items: center;justify-content: center;">
                            <div>
                                <div style="margin-bottom: 10px;display: inline-block">
                                    <el-icon :size="20">
                                        <Rank/>
                                    </el-icon>
                                </div>
                                <div style="margin-left:15px;margin-bottom: 10px;cursor: pointer;display: inline-block"
                                     @click="remove_item(index, element)">
                                    <el-icon :size="20">
                                        <Delete/>
                                    </el-icon>
                                </div>
                            </div>
                            <div style="height: 30px;line-height: 30px;font-size: 14px;cursor: pointer;"
                                 @click="show_detail_fun(index, element)">
                                专业({{ element.sub_plan_ids.length }})
                                <el-icon>
                                    <ArrowDown/>
                                </el-icon>
                            </div>
                        </div>
                    </div>
                    <div v-show="element.show_more">
                        <SchoolGroupInfo :batch_model="batch_model" @un_favorite="un_favorite"
                                         @sub_rank_change="sub_rank_change"
                                         :favorite_list="element.sub_plan_ids"></SchoolGroupInfo>
                    </div>
                </div>
            </template>
        </draggable>
    </div>
</template>

<script>
import draggable from 'vuedraggable'
import {ElNotification} from "element-plus";
import SchoolGroupInfo from "@/components/SchoolGroupInfo.vue";

export default {
    components: {
        SchoolGroupInfo,
        draggable
    },
    props: {
        favorite_list: {
            type: Array,
            default: [],
        },
        batch_model: {
            type: String,
            default: '',
        },
        rank_change: {
            type: Function,
            default: null
        },
        un_favorite: {
            type: Function,
            default: null
        },
        sub_plans_list: {
            type: Function,
            default: null
        },
        show_detail: {
            type: Function,
            default: null
        },
    },
    watch: {
        favorite_list: {
            handler(new_list, old_list) {
                for (let i in new_list) {
                    if (new_list[i]['sub_plan_ids'] === undefined) {
                        new_list[i]['sub_plan_ids'] = []
                    }
                }
                this.list = new_list
            },
            deep: true
        },
    },
    data() {
        return {
            drag: false,
            list: [],
            chose_plans_num: {},
            index: 0,
            index_rank: '',
        };
    },
    methods: {
        list_change(e) {
            let info = e['moved']['element']
            info.user_score_rank = (e['moved']['newIndex'] + 1)
            this.$emit('rank_change', {'info': info, 'type': 1})
        },
        input(e) {
            this.index_rank = e.replace(/[^\d]/g, '')
        },
        change_rank(info, index) {
            
            let el_popover_index = 'el_popover_' + index
            let new_rank = this.index_rank.replace(/[^\d]/g, '')
            if (new_rank === '' || new_rank < 1 || new_rank > this.list.length) {
                ElNotification({
                    title: '提醒',
                    message: '请输入正确的志愿号!',
                    type: 'warning',
                })
                return false
            }
            this.index_rank = ''
            
            
            info.user_score_rank = new_rank
            this.$refs[el_popover_index].hide()
            this.$emit('rank_change', {'info': info, 'type': 1})
        },
        remove_item(index, plan_info, type = 1) {
            this.$emit('un_favorite', {"index": index, "list": plan_info, "del_all": 1, "type": type})
        },
        sub_rank_change(param) {
            //console.log(param)
            this.$emit('rank_change', param)
        },
        show_detail_fun(index, plan_info) {
            let match_id = parseInt(index)
            
            this.list[match_id].show_more = !this.list[match_id].show_more
            let obj = {
                school_id: this.list[index]['school_id'],
                major_group_code: this.list[index]['major_group_code'],
                danlie_biaoshi: this.list[index]['danlie_biaoshi'],
                danlie_group_key: this.list[index]['danlie_group_key'],
                sub_plan_ids: this.list[index]['sub_plan_ids'],
                major_limit: this.list[index]['major_limit'],
            }
            this.$emit('sub_plans_list', obj)
        },
        
        un_favorite(param) {
            //console.log(param)
            this.$emit('un_favorite', param)
        },
    },
};
</script>
<style scoped>
.drag_content {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: white;
    margin: 0 auto;
}

.drag_content_info {
    position: relative;
    display: flex;
    justify-content: space-around;
    align-items: center;
    border-radius: 5px;
    margin: 10px 15px 0 10px;
    padding: 5px 10px;
    border: 1px rgba(0, 0, 0, 0.12) solid;
    cursor: all-scroll;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.12);
}

.drag_content_list {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
}

.drag_content_list_item {
    width: 750px;
    height: 30px;
    display: flex;
    margin-right: 5px;
    justify-content: left;
    align-items: center;
}

.gailv_chongwenbao {
    position: absolute;
    top: 0;
    left: 0;
    width: 23px;
    height: 32px;
    margin-left: 5px;
    font-weight: normal;
    display: flex;
    font-family: 'San Francisco', 'Droid Sans';
    color: white;
    font-size: 9px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2px 2px 0 2px;
}
</style>